import React from 'react';
import { Box, Checkbox, Radio, rem } from '@mantine/core';
import type { TypeFilterOption } from '@/types/list/types.list.filter';

type Props = {
    option: TypeFilterOption;
    checked: boolean;
    single?: boolean;
    context?: string;
    onToggle: () => void;
};

const FilterOption: React.FC<Props> = ({ option, checked, single = false, context, onToggle }) => {
    const empty = option.count === 0 && !checked;
    const Control = single ? Radio : Checkbox;
    return (
        <Box component="label" className="bd-fp-option" data-checked={checked || undefined} data-empty={empty || undefined}>
            <Control size="xs" checked={checked} onChange={onToggle} disabled={empty} aria-label={context ? `${context}: ${option.label}` : option.label} />
            {option.dot ? <Box aria-hidden style={{ width: rem(8), height: rem(8), borderRadius: '50%', flexShrink: 0, backgroundColor: option.dot }} /> : null}
            <span className="bd-fp-option-label" title={option.label}>{option.label}</span>
            {context ? <span className="bd-fp-option-context">{context}</span> : null}
            {option.count !== undefined ? <span className="bd-fp-option-count">{option.count}</span> : null}
        </Box>
    );
};

export default FilterOption;
